import Course from './Course'
import Lesson from './Lesson'
import Router from 'next/router'
import Auth from './Auth'

var follow = (link) => {
    return ()=>(document.location.href=link)
}


export var GetCourseList = ({data})=>{
    if (!data.coursesAvailable || data.coursesAvailable.length==0) return <div>Не найдено</div>

    return data.coursesAvailable&&data.coursesAvailable.map((course,idx)=>(<div key={idx} onClick={follow("?course="+course.slug)}><Course {...course} /></div>))
}

export var GetLesson = ({data,currentCourse,currentLesson}) =>{
    var course =data.coursesAvailable&&data.coursesAvailable.find(course=>course.slug==currentCourse)
    if (course) {
        var lesson =course.lessonsAvailable&&course.lessonsAvailable.find(course=>course.index==currentLesson)
        if (lesson){
             return <Lesson full {...lesson}/>
        }
    }
}

export var GetCourse = ({data,currentCourse}) => {
    var course =data.coursesAvailable&&data.coursesAvailable.find(course=>course.slug==currentCourse)  
    if (course) {
        return (<Course full {...course}/>) 
    }
}

export var getCrumbs = (data,currentCourse,currentLesson)=>{
    var crumbs=[{name:"Курсы Seva Prem",link:'/'}]
    if (currentCourse) {
        var course =data.coursesAvailable&&data.coursesAvailable.find(course=>course.slug==currentCourse)
        if (course) {
            crumbs.push({name:course.heading,link:"/?course="+course.slug})
        }
        if (currentLesson){
            crumbs.push({name:"Урок "+currentLesson,link:"/?course="+course.slug+"&lesson="+currentLesson})
        }
    }
    return crumbs
}
